<template>
    <main class="main subscribe-page">
        <section class="subscribe-page__section">
            <div class="container">
                <div class="subscribe-page__block">
                    <EmailSubscriptionContent inline />
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import EmailSubscriptionContent from '@/src/components/Airs/EmailSubscriptionContent.vue';

export default {
    name: 'Subscribe',
    components: { EmailSubscriptionContent },
}
</script>

<style lang="scss" scoped>
.subscribe-page__section {
    padding: 40px 0 60px;
}
.subscribe-page__block {
    max-width: 640px;
    margin: 0 auto;
    background: #fff;
    padding: 20px;
}
@media screen and (max-width: 768px) {
    .subscribe-page__section {
        padding: 24px 0 40px;
    }
    .subscribe-page__block {
        padding: 15px;
    }
}
</style>
